import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import _ from "lodash";
import { getClinics ,getAllClinicspatientportal} from "../../apis/clinicSlice";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";


const SearchClinic = ({ open, setData, data, variant, label, name, size, disabled, showAddress  }) => {
  const dispatch = useDispatch();

  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);

  const location = useLocation();
const isPatientCalendar = location.pathname === "/patientcalendar";


  // const fetchOptions = useMemo(
  //   () =>
  //     _.debounce(async (query) => {
  //       setLoading(true);
  //       try {
  //         const response = await dispatch(getClinics({ search: query }));
  //         setOptions(
  //           response?.payload?.data?.map((item) => ({
  //             label: item.name,
  //             value: item._id,
  //             ...item,
  //           })) || [],
  //         );
  //       } catch (err) {
  //         console.error(err);
  //       } finally {
  //         setLoading(false);
  //       }
  //     }, 600),
  //   [dispatch],
  // );

  const fetchOptions = useMemo(
  () =>
    _.debounce(async (query) => {
      setLoading(true);
      try {
        const action = isPatientCalendar
          ? getAllClinicspatientportal({ search: query }) // no auth
          : getClinics({ search: query });                // auth

        const response = await dispatch(action);

        setOptions(
          response?.payload?.data?.map((item) => ({
            label: item.name,
            value: item._id,
            ...item,
          })) || []
        );
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }, 600),
  [dispatch, isPatientCalendar]
);

  useEffect(() => {
    if (open) {
      fetchOptions(inputValue);
    }
  }, [open, inputValue]);

  const handleChange = (e, newValue) => {
    // set the raw id/object into parent form
    setData((prev) => ({ ...prev, [name]: newValue ? newValue.value || newValue._id || newValue : null }));
  };

  return (
    <Autocomplete
      options={options}
      getOptionLabel={(option) => option.label || ""}
      value={
        data && data[name]
          ? typeof data[name] === 'string' 
            ? options.find((o) => o.value === data[name]) || null
            : data[name]
          : null
      }
      loading={loading}
      size={size || "medium"}
      onChange={handleChange}
      disabled={disabled}
      onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
      renderOption={(props, option) => (
        <li {...props} key={option.value}>
          <div>
            <div style={{ fontWeight: 500 }}>{option.label}</div>
            {showAddress && option.address && (
              <div style={{ fontSize: '0.875rem', color: '#666' }}>
                {option.address}
              </div>
            )}
          </div>
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label || "Select Clinic"}
          variant={variant}
          required
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading && <CircularProgress color="inherit" size={20} />}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default SearchClinic;
